module.exports = __webpack_public_path__ + "static/media/NL nieuw.9b33f8be.svg";